import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import {
  ProductFilters,
  ProductFiltersPanel,
} from '../product-filters-panel/product-filters-panel';

@Component({
  selector: 'app-product-filters-bottom-sheet',
  imports: [ProductFiltersPanel, FormsModule, MatButtonModule],
  templateUrl: './product-filters-bottom-sheet.html',
  styleUrl: './product-filters-bottom-sheet.scss',
})
export class ProductFiltersBottomSheet {
  constructor(
    private bottomSheetRef: MatBottomSheetRef<ProductFiltersBottomSheet>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: ProductFilters
  ) {}

  close() {
    this.bottomSheetRef.dismiss();
  }
  confirm() {
    this.bottomSheetRef.dismiss(this.data);
  }
}
